import { render, staticRenderFns } from "./ProgramForm.vue?vue&type=template&id=d567c7f4&scoped=true"
import script from "./ProgramForm.vue?vue&type=script&lang=js"
export * from "./ProgramForm.vue?vue&type=script&lang=js"
import style0 from "./ProgramForm.vue?vue&type=style&index=0&id=d567c7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d567c7f4",
  null
  
)

export default component.exports